import { render, staticRenderFns } from "./club-contacts.vue?vue&type=template&id=49e354f2&scoped=true&"
import script from "./club-contacts.vue?vue&type=script&lang=ts&"
export * from "./club-contacts.vue?vue&type=script&lang=ts&"
import style0 from "./club-contacts.vue?vue&type=style&index=0&id=49e354f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e354f2",
  null
  
)

export default component.exports